import { Button } from "@saleor/macaw-ui-next";
import { Bell } from "lucide-react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { portalMessages as m } from "./messages";
import { portalPaths } from "./urls";

export const NotificationsBell = ({ unread }: { unread: number }) => {
  const intl = useIntl();

  return (
    <Link to={portalPaths.notifications} title={intl.formatMessage(m.notifications)}>
      <Button
        variant="tertiary"
        size="small"
        as="span"
        aria-label={intl.formatMessage(m.notifications)}
      >
        <Bell size={16} />
        {unread > 0 ? ` ${unread}` : ""}
      </Button>
    </Link>
  );
};
